import { api } from '../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../shared/api/genexus-query';
import type { DataTableQuery } from '../../shared/components/DataTable';
import type { ProjectListFilters, ProjectListItem } from './types';

const BASE = '/v1/projects';

export const projectsApi = {
  /**
   * List unificado. Quando `filters.apontavelParaColaborador` está setado,
   * troca a rota para `/clients/:clienteId/projects` (sub-recurso aninhado,
   * que é onde o GeneXus aceita o filtro de alocação — T-20b). Senão usa o
   * endpoint global `/projects`. Em ambos os casos, o front lê o mesmo
   * DTO `ProjectListItem`.
   */
  async list(
    query: DataTableQuery,
    filters?: ProjectListFilters,
  ): Promise<ListEnvelope<ProjectListItem>> {
    const apontavelPara = filters?.apontavelParaColaborador ?? null;
    if (apontavelPara !== null && filters?.clienteId != null) {
      const { data } = await api.get<{
        data: ProjectListItem[];
        meta: { total: number; pagina?: number; porPagina?: number };
      }>(`/v1/clients/${filters.clienteId}/projects`, {
        params: toGenexusParams(query, { apontavelParaColaborador: apontavelPara }),
      });
      return normalizeListEnvelope(data);
    }
    const { data } = await api.get<{
      data: ProjectListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, {
      params: toGenexusParams(query, {
        clienteId: filters?.clienteId ?? undefined,
        clienteAtivo: filters?.clienteAtivo,
      }),
    });
    return normalizeListEnvelope(data);
  },
};
